var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftLineIcon24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#5f5f5f",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-arrow-left-from-line",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9 6-6 6 6 6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12h14"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 19V5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftLineIcon24);
export default __webpack_public_path__ + "static/media/arrowLeftLineIcon24.ea2d64a5986d2cd48c75526e08986ebf.svg";
export { ForwardRef as ReactComponent };